import { useEffect, useState } from 'react'
import { Col, Row, Form } from 'react-bootstrap'
import { Radio, RadioGroup } from 'rsuite'
import api from '../../services/api'
import './styles.css'

import NavBar from '../../components/NavBar/NavBar.js'
import CorpoReport from '../../components/CorpoBackups/ReportSemanaAll'

function ReportSemanal() {
  const [body, setBody] = useState([])
  const [type, setType] = useState(true)
  const [typeCheck, setTypeCheck] = useState(false)

  const getData = async () => {
    await api.get('/empresas?ativa=1').then((response) => {
      const respost = response.data
      setBody(respost)
    })
  }
  useEffect(() => {
    getData()
  }, [])

  return (
    <NavBar>
      <Row xs={1} className="g-3">
        <RadioGroup
          name="radioList"
          inline
          appearance="picker"
          defaultValue="C"
        >
          <Radio
            value="C"
            onClick={() => {
              setType(true)
              setTypeCheck(false)
            }}
          >
            {' '}
            Contrato
          </Radio>
          <Radio
            value="A"
            onClick={() => {
              setType(false)
              setTypeCheck(false)
            }}
          >
            {' '}
            Avulso
          </Radio>
          <Radio
            value="B"
            onClick={() => {
              setType(false)
              setTypeCheck(true)
            }}
          >
            {' '}
            Sem verificação
          </Radio>
        </RadioGroup>
        {!type && typeCheck &&
          body
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((body) => {
              if (body.contrato === 'Contrato')
                return <CorpoReport key={body.id} info={body}  not={1} />
            })}
        {type && !typeCheck &&
          body
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((body) => {
              if (body.contrato === 'Contrato')
                return <CorpoReport key={body.id} info={body} />
            })}
        {!type && !typeCheck &&
          body
            .sort((a, b) => a.name.localeCompare(b.name))
            .map((body) => {
              if (body.contrato !== 'Contrato')
                return <CorpoReport key={body.id} info={body} />
            })}
        <br />
      </Row>
    </NavBar>
  )
}

export default ReportSemanal
